'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Mobile = require('./Mobile/Mobile');

var _Mobile2 = _interopRequireDefault(_Mobile);

var _Seo = require('./Seo/Seo');

var _Seo2 = _interopRequireDefault(_Seo);

var _LAFooter = require('./LAFooter.scss');

var _LAFooter2 = _interopRequireDefault(_LAFooter);

var _Support = require('./Support/Support');

var _Support2 = _interopRequireDefault(_Support);

var _Trust = require('./Trust/Trust');

var _Trust2 = _interopRequireDefault(_Trust);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LAFooter = (_temp = _class = function (_PureComponent) {
    (0, _inherits3.default)(LAFooter, _PureComponent);

    function LAFooter() {
        (0, _classCallCheck3.default)(this, LAFooter);
        return (0, _possibleConstructorReturn3.default)(this, (LAFooter.__proto__ || (0, _getPrototypeOf2.default)(LAFooter)).apply(this, arguments));
    }

    (0, _createClass3.default)(LAFooter, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                baseUrl = _props.baseUrl,
                classicBaseUrl = _props.classicBaseUrl,
                email = _props.email,
                fullName = _props.fullName,
                openDownloadMobileModal = _props.openDownloadMobileModal,
                openHealthcheckModal = _props.openHealthcheckModal,
                year = _props.year;


            return (0, _jsx3.default)('div', {
                className: _LAFooter2.default.footer
            }, void 0, (0, _jsx3.default)(_Mobile2.default, {}), (0, _jsx3.default)(_Trust2.default, {}), (0, _jsx3.default)(_Seo2.default, {}), (0, _jsx3.default)(_Support2.default, {
                baseUrl: baseUrl,
                classicBaseUrl: classicBaseUrl,
                email: email,
                fullName: fullName,
                openDownloadMobileModal: openDownloadMobileModal,
                openHealthcheckModal: openHealthcheckModal,
                year: year
            }));
        }
    }]);
    return LAFooter;
}(_react.PureComponent), _class.defaultProps = {
    email: '',
    fullName: ''
}, _temp);
exports.default = LAFooter;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/LAFooter/LAFooter.js
// module id = Pv7X
// module chunks = 60